import axios from 'axios';

function getBaseURL() {
  return process.env.NODE_ENV === "development" ? 'http://www.zhoaoss.com' : 'https://api.oa.gdzawy.com:9001'
}


const instance = axios.create({
  baseURL: getBaseURL() + '/oa/'
});

instance.interceptors.request.use(function (config) {

  config.params.login_name = localStorage.getItem('login')
  config.params.token = localStorage.getItem('token')

  return config;
});

function DateFormat(date) {
  let year = date.getFullYear();
  let month = ("0" + (date.getMonth() + 1)).slice(-2);
  let sdate = ("0" + date.getDate()).slice(-2);
  return year + '-' + month + '-' + sdate
}

const ErrorResponse = {code: 400, msg: '网络错误'}

const Admin = {

  getInfo(params, callback) {
    instance.get('admin/getInfo', {params: params}).then(resp => {
      callback(resp.data)
    })
  },

  add(data, callback) {
    instance.post('admin/add', data).then(resp => {
      callback(resp.data)
    })
  },

  getList(params, callback) {
    instance.get('admin/getList', {params: params}).then(resp => {
      callback(resp.data)
    }).catch(error => callback(ErrorResponse))
  },

  updateStatus(data, callback) {
    instance.post('admin/updateStatus', data).then(resp => {
      callback(resp.data)
    })
  },

  delete(data, callback) {
    instance.post('admin/delete', data).then(resp => {
      callback(resp.data)
    })
  },

  getWorkClass(params, callback) {
    instance.get('admin/getWorkClass', {params: params}).then(resp => {
      callback(resp.data)
    })
  },

  save(data, callback) {
    instance.post('admin/save', data).then(resp => {
      callback(resp.data)
    })
  },

  getAreaList(callback) {
    instance.get('admin/getAreaList').then(resp => {
      callback(resp.data)
    })
  }
}

const User = {

  getList(params, callback) {
    instance.get('user/getList', {params: params}).then(resp => {
      callback(resp.data)
    }).catch(error => callback(ErrorResponse))
  },

  getSexText(sex) {
    switch (Number(sex)) {
      case 1 :
        return '男';
      case 2 :
        return '女';
      default:
        '未知';
    }
  },

  getUserWorkClass(params, callback) {
    instance.get('userclass/getUserWorkClass', {params: params}).then(resp => {
      callback(resp.data)
    })
  },
}

const UserManage = {

  getUserDepartment(params, callback) {
    instance.get('usermanage/getUserDepartment', {params: params}).then(resp => {
      callback(resp.data)
    })
  },

  getDepartmentList(params, callback) {
    instance.get('usermanage/getDepartmentList', {params: params}).then(resp => {
      callback(resp.data)
    })
  },

  getDepartmentMember(params, callback) {
    instance.get('usermanage/getDepartmentMember', {params: params}).then(resp => {
      callback(resp.data)
    })
  },

  //加法函数，用来得到精确的加法结果
  //说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
  //调用：Add(arg1,arg2)
  //返回值：arg1加上arg2的精确结果
  Add(arg1, arg2) {
    arg1 = parseFloat(arg1);
    arg2 = parseFloat(arg2);
    var r1, r2, m;
    try {
      r1 = arg1.toString().split(".")[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = arg2.toString().split(".")[1].length
    } catch (e) {
      r2 = 0
    }
    m = Math.pow(100, Math.max(r1, r2));
    return (this.Mul(arg1, m) + this.Mul(arg2, m)) / m;
  },

//减法函数，用来得到精确的减法结果
//说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的减法结果。
//调用：Sub(arg1,arg2)
//返回值：arg1减去arg2的精确结果
  Sub(arg1, arg2) {
    arg1 = parseFloat(arg1);
    arg2 = parseFloat(arg2);
    var r1, r2, m, n;
    try {
      r1 = arg1.toString().split(".")[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = arg2.toString().split(".")[1].length
    } catch (e) {
      r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2));
    //动态控制精度长度
    n = (r1 >= r2) ? r1 : r2;
    return ((this.Mul(arg1, m) - this.Mul(arg2, m)) / m).toFixed(n);
  },

//乘法函数，用来得到精确的乘法结果
//说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
//调用：Mul(arg1,arg2)
//返回值：arg1乘以arg2的精确结果
  Mul(arg1, arg2) {
    arg1 = parseFloat(arg1);
    arg2 = parseFloat(arg2);
    var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
    try {
      m += s1.split(".")[1].length
    } catch (e) {
    }
    try {
      m += s2.split(".")[1].length
    } catch (e) {
    }
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
  },

//除法函数，用来得到精确的除法结果
//说明：javascript的除法结果会有误差，在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。
//调用：Div(arg1,arg2)
//返回值：arg1除以arg2的精确结果
  Div(arg1, arg2) {
    arg1 = parseFloat(arg1);
    arg2 = parseFloat(arg2);
    var t1 = 0, t2 = 0, r1, r2;
    try {
      t1 = arg1.toString().split(".")[1].length;
    } catch (e) {
    }
    try {
      t2 = arg2.toString().split(".")[1].length;
    } catch (e) {
    }
    r1 = Number(arg1.toString().replace(".", ""));
    r2 = Number(arg2.toString().replace(".", ""));
    return this.Mul(r1 / r2, Math.pow(10, t2 - t1));
  },

}

export {
  DateFormat,
  Admin,
  User,
  instance,
  UserManage,
  get,
  post,
  getBaseURL,
}



// WEBPACK FOOTER //
// ./src/components/Admin/Oa/common.js